import * as printConst  from './constant'
// import {electronPrint} from './electronPrint'
import {cloudPrint} from './cloudPrint'
import { soapPost } from '../ajaxSoap'
import { bizTypeMap } from '../bizTypeMapping'
import {SgmPrintMonitor} from '@/api/lib/monitor/printMonitor'
import route from '@/router.js'
import store from '@/store/store.js';

/**
 * 打印入口
 * @param content
 * @param printNum 打印份数
 */
export async function print (content,printNum = 1) {
  if (printConst.DEFINE_PRINT_WAY === printConst.PRINT_WAY.CLOUD_PRINT) {
    console.log("采用云打印方式...",content)
    let startTime = new Date().getTime();
    let printRet = await cloudPrint(content,printNum);
    let endTime = new Date().getTime();
    SgmPrintMonitor('cloudPrint', endTime - startTime, {time: endTime - startTime, ...content})
    return printRet;
  } else {
    console.log("采用Electron打印方式...")
    // electronPrint(content)  
  }
}


// 收集需要打印的所有面单信息
export const collectLabelInfo = labelInfo => {
  if (!['suPackNew', 'customRecheckGoods', 'sortingRecheck', 'guidedPack', 'guidedPackRefactor'].includes(route.history.current.name)) {
    return;
  }
  const printArr = store.getters.printPaperInfo;
  let {type, size = '', num = 1} = labelInfo;
  if (size) {
    size = size.replace(',', '*');
  }
  printArr.push({
    type,
    size,
    num
  });
  store.commit('SER_PRINT_PAPER_INFO', printArr)
}

// 展现面单确认弹窗
export const showWaybillDialog = () => {
  if (!['suPackNew', 'customRecheckGoods', 'sortingRecheck', 'guidedPack', 'guidedPackRefactor'].includes(route.history.current.name)) {
    return;
  }
  const printArr = store.getters.printPaperInfo;
  if (printArr && printArr.length) {
    store.commit('SET_WAYBILL_DIALOG_SHOW', true)
  }
}

export const queryPrintCN23 = async (query) => {
  var ret = null
  await soapPost(bizTypeMap.queryPrintCN23, query)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const query3PLFaceParams = async (query) => {
  var ret = null
  await soapPost(bizTypeMap.query3PLFaceParams, query)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const convertBase64 = async (query) => {
  var ret = null
  await soapPost(bizTypeMap.convertBase64, query)
    .done(function (data) {
      ret = data
    })
  return ret
}

export const exportCN23List = async (query) => {
  var ret = null
  await soapPost(bizTypeMap.exportCN23List, query)
    .done(function (data) {
      ret = data
    })
  return ret
}
